import { Field } from '@kanda-libs/ks-component-ts';
import { BUDGET_VALIDATION, CLASS_NAMES, COPY } from './constants';
import EnquiryProjectBudgetFormFieldsProjectBudgetInterestInCredit from './InterestInCredit';
import useEnquiryProjectBudgetFormFields from './useEnquiryProjectBudgetFormFields';

const EnquiryProjectBudgetFormFieldsProjectBudget: React.FunctionComponent =
  function () {
    const { options } = useEnquiryProjectBudgetFormFields();
    return (
      <div className="flex flex-col">
        <h1 className={CLASS_NAMES.header}>{COPY.header}</h1>
        <h3 className={CLASS_NAMES.subheader}>{COPY.subheader1}</h3>
        <h3 className={CLASS_NAMES.subheader}>{COPY.subheader2}</h3>
        <EnquiryProjectBudgetFormFieldsProjectBudgetInterestInCredit />
        <Field.Validator validation={BUDGET_VALIDATION}>
          <Field.Select
            options={options}
            name="budget"
            placeholder="Select..."
            label="Project budget"
          />
        </Field.Validator>
      </div>
    );
  };

export default EnquiryProjectBudgetFormFieldsProjectBudget;
